import React, {
  PropTypes as T,
} from 'react';
import radium from 'radium';
import _ from 'lodash';

const style = {
  wrap: {
    width: '100%',
    maxWidth: 720,
    height: 'auto',
    margin: '0px auto',
    padding: '10px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  node: {
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      flex: 1,
    },
  },
  circle: {
    display: 'block',
    width: 90,
    height: 90,
    borderRadius: '50%',
    opacity: 0.4,
    fontSize: 30,
    color: 'white',
    textAlign: 'center',
    '@media (max-width: 767px)': {
      width: 40,
      height: 40,
    },
  },
  active: {
    opacity: 1,
  },
  chevron: {
    margin: '0 10px',
    fontSize: 30,
    fontWeight: 100,
    '@media (max-width: 767px)': {
      fontSize: 15,
      margin: '0 5px',
    },
  },
  text: {
    lineHeight: '90px',
    '@media (max-width: 767px)': {
      lineHeight: '40px',
      fontSize: 12,
      padding: 0,
    },
  },
};

function ProgressNavi(props) {
  const count = props.count;
  const styles = _.cloneDeep(style);
  styles.circle.backgroundColor = props.color;
  styles.chevron.color = props.color;
  return (
    <div style={styles.wrap}>
      {Array.apply(null, { length: count }).map((n, idx) => {
        const activeStep = props.step - 1 === idx;
        if (idx === count - 1) {
          return (
            <div style={styles.node} key={idx}>
              <span style={[styles.circle, styles.single, activeStep && styles.active]}>
                <span style={styles.text}>Q{idx + 1}</span>
              </span>
            </div>
          );
        }
        return (
          <div style={styles.node} key={idx}>
            <span style={[styles.circle, activeStep && styles.active]}>
              <span style={styles.text}>Q{idx + 1}</span>
            </span>
            <span style={styles.chevron} className="fa fa-chevron-right"></span>
          </div>
        );
      })}
    </div>
  );
}

ProgressNavi.propTypes = {
  count: T.number,
  step: T.number,
  color: T.string,
};

export default radium(ProgressNavi);



// WEBPACK FOOTER //
// ./components/ProgressNavi.js